import DocumentError from './DocumentError';

export default DocumentError;
